import { render } from "./SupportVolunteer.vue?vue&type=template&id=6d295528&scoped=true"
import script from "./SupportVolunteer.vue?vue&type=script&lang=js"
export * from "./SupportVolunteer.vue?vue&type=script&lang=js"

import "./SupportVolunteer.vue?vue&type=style&index=0&id=6d295528&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d295528"]])

export default __exports__